<template>
  <div>
    <div class="columns is-gapless is-vcentered has-bg-light is-min-height-50">
      <div class="column is-padding-left is-padding-right">
        <div class="is-size-6">
          <strong class="">Période</strong>
          <span class="has-text-weight-normal">de</span>
          <span class="has-text-grey is-underline has-text-weight-normal is-dotted"
          >{{startDateLabel}}</span>
          <span class="has-text-weight-normal">à</span>
          <span class="has-text-grey is-underline has-text-weight-normal is-dotted"
          >{{endDateLabel}}</span>
        </div>
      </div>
      <!-- <div class="column is-narrow">
        <a class="has-text-grey is-uppercase is-size-6">
          <span class="icon is-small"><i class="fal fa-external-link-square"></i></span>
          <span>Exporter</span>
        </a>
      </div> -->
    </div>
    <div class="columns is-multiline is-border-top" v-if="showfakeStats">
      <div class="column is-4 is-border-right is-border-dashed columns is-column is-space-between">
        <div class="has-text-grey">Nombre d'options</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-4 has-text-weight-medium">34
            <sup class="is-size-5" v-if="34">
              <i class="fal fa-arrow-right has-text-success is-rotate-315"></i>
            </sup>
          </div>
          <div class="is-marginless is-size-7 has-text-success">
            +11
          </div>
        </div>
      </div>
      <div class="column is-4 is-border-right is-border-dashed columns is-column is-space-between">
        <div class="has-text-grey">Nombre de réservations</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-4 has-text-weight-medium">17
            <sup class="is-size-5">
              <i class="fal fa-arrow-right has-text-success is-rotate-315"></i>
            </sup>
          </div>
          <div class="is-marginless is-size-7 has-text-success">
            +4
          </div>
        </div>
      </div>
      <div class="column is-4 columns is-column is-space-between is-border-dashed">
        <div class="has-text-grey">Nombre d'annulations</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-4 has-text-weight-medium">3
            <sup class="is-size-5">
              <i class="fal fa-arrow-right has-text-danger is-rotate-45"></i>
            </sup>
          </div>
          <div class="is-marginless is-size-7 has-text-danger">
            - 2
          </div>
        </div>
      </div>
      <div class="column is-4 is-border-right is-border-dashed is-border-top columns is-column is-space-between">
        <div class="has-text-grey">Total vente CA</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-3 has-text-weight-medium">4 250 000 {{$currency}}
            <sup class="is-size-5">
              <i class="fal fa-arrow-right is-rotate-315 has-text-success"></i>
            </sup>
          </div>
          <div class="is-marginless is-size-7 has-text-success">
            +129 500 {{$currency}}
          </div>
        </div>
      </div>
      <div class="column is-4 is-border-right is-border-dashed is-border-top columns is-column is-space-between">
        <div class="has-text-grey">Prix ventes moyen</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-4 has-text-weight-medium">250 000 {{$currency}}
            <sup class="is-size-5">
              <i class="fal fa-arrow-right is-rotate-315 has-text-success"></i>
            </sup>
          </div>
          <div class="is-marginless is-size-7 has-text-success">
            + 33 300 {{$currency}}
          </div>
        </div>
      </div>
      <div class="column is-4 is-border-top is-border-dashed columns is-column is-space-between">
        <div class="has-text-grey">Nombre de ventes nettes</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-4 has-text-weight-medium">14
            <sup class="is-size-5">
              <i class="fal fa-arrow-right is-rotate-45 has-text-danger"></i>
            </sup>
          </div>
          <div class="is-marginless is-size-7 has-text-danger">
            - 2
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline is-border-top" v-else-if="stats && previousStats">
      <div class="column is-4 is-border-right is-border-dashed columns is-column is-space-between">
        <div class="has-text-grey">Nombre d'options</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-4 has-text-weight-medium">{{periodOptions}}
            <sup class="is-size-5" v-if="showfakeStats">
              <i class="fal fa-arrow-right has-text-success is-rotate-315"></i>
            </sup>
            <sup class="is-size-5" v-else-if="pastOptions">
              <i class="fal fa-arrow-right has-text-success"
                 :class="pastOptions >= 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
            </sup>
          </div>
          <div v-if="showfakeStats" class="is-marginless is-size-7 has-text-success">
            + 3
          </div>
          <div v-else class="is-marginless is-size-7 has-text-success">
            <span v-if="pastOptions >= 0">+ </span>{{pastOptions}}
          </div>
        </div>
      </div>
      <div class="column is-4 is-border-right is-border-dashed columns is-column is-space-between">
        <div class="has-text-grey">Nombre de réservations</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-4 has-text-weight-medium">{{stats.reservationsCounts}}
            <sup class="is-size-5" v-if="showfakeStats">
              <i class="fal fa-arrow-right has-text-success is-rotate-315"></i>
            </sup>
            <sup class="is-size-5" v-else-if="evoReservationCount">
              <i class="fal fa-arrow-right has-text-success"
                 :class="evoReservationCount >= 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
            </sup>
          </div>
          <div v-if="showfakeStats" class="is-marginless is-size-7 has-text-success">
            + 4
          </div>
          <div v-else class="is-marginless is-size-7 has-text-success">
            <span v-if="evoReservationCount >= 0">+ </span>{{evoReservationCount}}
          </div>
        </div>
      </div>
      <div class="column is-4 columns is-column is-space-between is-border-dashed">
        <div class="has-text-grey">Nombre d'annulations</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-4 has-text-weight-medium">{{stats.cancelCounts}}
            <sup class="is-size-5" v-if="showfakeStats">
              <i class="fal fa-arrow-right has-text-success is-rotate-315"></i>
            </sup>
            <sup class="is-size-5" v-else-if="evoCancelCount">
              <i class="fal fa-arrow-right has-text-success"
                 :class="evoCancelCount >= 0 ? 'is-rotate-315 has-text-danger' : 'is-rotate-45 has-text-success'"></i>
            </sup>
          </div>
          <div v-if="showfakeStats" class="is-marginless is-size-7 has-text-success">
            - 4
          </div>
          <div v-else class="is-marginless is-size-7"
               :class="evoCancelCount >= 0 ? 'has-text-danger' : 'has-text-succes'">
            <span v-if="evoCancelCount >= 0">+ </span>{{evoCancelCount | prettyPrice}}
          </div>
        </div>
      </div>
      <div class="column is-4 is-border-right is-border-dashed is-border-top columns is-column is-space-between">
        <div class="has-text-grey">Total vente CA</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-3 has-text-weight-medium">{{stats.CA | prettyPrice}} {{$currency}}
            <sup class="is-size-5" v-if="showfakeStats">
              <i class="fal fa-arrow-right has-text-success is-rotate-315"></i>
            </sup>
            <sup class="is-size-5" v-else-if="evoCA">
              <i class="fal fa-arrow-right has-text-success"
                 :class="evoCA >= 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
            </sup>
          </div>
          <div v-if="showfakeStats" class="is-marginless is-size-7 has-text-success">
            + 34%
          </div>
          <div v-else class="is-marginless is-size-7" :class="evoCA >= 0 ? 'has-text-success' : 'has-text-danger'">
            <span v-if="evoCA >= 0">+ </span>{{evoCA | prettyPrice}} {{$currency}}
          </div>
        </div>
      </div>
      <div class="column is-4 is-border-right is-border-dashed is-border-top columns is-column is-space-between">
        <div class="has-text-grey">Prix ventes moyen</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-4 has-text-weight-medium">{{stats.avgCA | prettyPrice}}
            <sup class="is-size-5" v-if="showfakeStats">
              <i class="fal fa-arrow-right has-text-success is-rotate-315"></i>
            </sup>
            <sup class="is-size-5" v-else-if="evoAvgCA">
              <i class="fal fa-arrow-right has-text-success"
                 :class="evoAvgCA >= 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
            </sup>
          </div>
          <div v-if="showfakeStats" class="is-marginless is-size-7 has-text-success">
            + 34%
          </div>
          <div v-else class="is-marginless is-size-7" :class="evoAvgCA >= 0 ? 'has-text-success' : 'has-text-danger'">
            <span v-if="evoAvgCA >= 0">+ </span>{{evoAvgCA | prettyPrice}} {{$currency}}
          </div>
        </div>
      </div>
      <div class="column is-4 is-border-top is-border-dashed columns is-column is-space-between">
        <div class="has-text-grey">Nombre de ventes nettes</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-4 has-text-weight-medium">{{stats.salesCounts}}
            <sup class="is-size-5" v-if="showfakeStats">
              <i class="fal fa-arrow-right has-text-success is-rotate-315"></i>
            </sup>
            <sup class="is-size-5" v-else-if="evoSalesCount">
              <i class="fal fa-arrow-right"
                 :class="evoSalesCount >= 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
            </sup>
          </div>
          <div v-if="showfakeStats" class="is-marginless is-size-7 has-text-success">
            + 14%
          </div>
          <div v-else class="is-marginless is-size-7 has-text-danger">
            <span v-if="evoSalesCount >= 0">+ </span>{{evoSalesCount}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { isNumber } from 'lodash'
  import FakeStats from './FakeStats'

  export default {
    name: 'StatsPanel',
    components: { FakeStats },
    props: {
      company: {
        type: Object,
        required: true
      },
      salesStatsData: {
        type: Object,
        default: () => {},
        required: true
      },
      previousSalesStatsData: {
        type: Object,
        default: () => {},
        required: true
      }
    },
    data () {
      return {
        loading: true,
        options: [],
        optionTotalCount: null
      }
    },
    computed: {
      showfakeStats () {
        return JSON.parse(this.$configs.FAKE_STATS) === 1
      },
      companyPk () {
        return this.company.pk
      },
      c () {
        return this.company
      },
      evoCA () {
        if (isNumber(this.stats.CA) && isNumber(this.previousStats.CA)) {
          return this.stats.CA - this.previousStats.CA
        } else {
          return 0
        }
      },
      evoAvgCA () {
        if (isNumber(this.stats.avgCA) && isNumber(this.previousStats.avgCA)) {
          return this.stats.avgCA - this.previousStats.avgCA
        } else {
          return 0
        }
      },
      evoSalesCount () {
        if (isNumber(this.stats.salesCounts) && isNumber(this.previousStats.salesCounts)) {
          return this.stats.salesCounts - this.previousStats.salesCounts
        } else {
          return 0
        }
      },
      evoCancelCount () {
        if (isNumber(this.stats.cancelCounts) && isNumber(this.previousStats.cancelCounts)) {
          return this.stats.cancelCounts - this.previousStats.cancelCounts
        } else {
          return 0
        }
      },
      evoReservationCount () {
        if (isNumber(this.stats.reservationsCounts) && isNumber(this.previousStats.reservationsCounts)) {
          return this.stats.reservationsCounts - this.previousStats.reservationsCounts
        } else {
          return 0
        }
      },
      stats () {
        return this.salesStatsData
      },
      previousStats () {
        return this.previousSalesStatsData
      },
      startDateLabel () {
        return moment().startOf('year').format('MMMM YYYY')
      },
      endDateLabel () {
        return moment(moment().endOf('month').toDate()).format('MMMM YYYY')
      },
      periodOptions () {
        return this.options.filter(x => {
          return moment(x.start_date) >= this.startDate && moment(x.end_date) < this.endDate
        }).length
      },
      pastOptions () {
        let delta = this.endDate.diff(this.startDate, 'days')
        let pastMonth = moment(this.startDate.clone().subtract(delta, 'days').startOf('month').toDate())
        return this.options.filter(x => {
          return moment(x.start_date) > pastMonth && moment(x.end_date) < this.startDate
        }).length
      },
      startDate () {
        return moment(moment().startOf('year').toDate()).clone().startOf('year')
      },
      endDate () {
        return moment(moment().endOf('month').toDate()).clone().endOf('month')
      }
    },
    methods: {
      getOptions () {
        let query = {
          company: this.companyPk,
          sort: 'created_on:desc'
        }
        this.$api.optionService.get(query).then(r => {
          this.options = this.options.concat(r.data.items)
          this.optionTotalCount = r.data.total
        })
      }
    },
    created () {
      this.getOptions()
      console.log(this.$configs)
    }
  }
</script>

<style>
  #startDatePicker, #endDatePicker {
    display: none !important;
    height: 0 !important;
    width: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/CompanyVuePanels/StatsPanel.vue